/* app/js/src/components/common/navbar-menu/navbar-menu.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.menu {
  position: absolute;
  right: 0;
  z-index: 5;
  background-color: #232f3a;
  padding: 0;
  top: 60px;
  min-width: 17vw;
  -webkit-box-shadow: 0px 1px 5px 0 rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 1px 5px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0px 1px 5px 0 rgba(0, 0, 0, 0.5);
  -webkit-animation-delay: 0s;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: fadeInFromBottom;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease;
  -moz-animation-delay: 0s;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: fadeInFromBottom;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -moz-animation-timing-function: ease;
  -o-animation-delay: 0s;
  -o-animation-duration: 0.2s;
  -o-animation-name: fadeInFromBottom;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  -o-animation-timing-function: ease;
  animation-delay: 0s;
  animation-duration: 0.2s;
  animation-name: fadeInFromBottom;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-timing-function: ease;
}
.menu::before {
  content: " ";
  border-top: 8px solid rgba(0, 0, 0, 0);
  border-right: 8px solid rgba(0, 0, 0, 0);
  border-left: 8px solid rgba(0, 0, 0, 0);
  border-bottom: 8px solid #232f3a;
  position: absolute;
  top: -16px;
  right: 1.3vw;
  z-index: 2;
}
.menu.animateOut {
  -webkit-animation-delay: 0s;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: fadeOutToBottom;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease;
  -moz-animation-delay: 0s;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: fadeOutToBottom;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -moz-animation-timing-function: ease;
  -o-animation-delay: 0s;
  -o-animation-duration: 0.2s;
  -o-animation-name: fadeOutToBottom;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  -o-animation-timing-function: ease;
  animation-delay: 0s;
  animation-duration: 0.2s;
  animation-name: fadeOutToBottom;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-timing-function: ease;
}
/*# sourceMappingURL=navbar-menu.component.css.map */
